namespace GeniuzPOS.InitialData {
    export enum RefundFg {
        Refund = 1,
        Cancel = 2
    }
    Serenity.Decorators.registerEnumType(RefundFg, 'GeniuzPOS.InitialData.RefundFg');
}
